/*
 * Copyright (c) Nexign, JSC, 2023.
 */
/**
 *
 *
 * @author Evgeniy Naumov
 * @version 1.25.0
 * @since 1.25.0
 */

import styled from 'styled-components';

export const SettingsNotificationsFormControls = styled.div`
    margin-top: 32px;
`;
